import { initSentry } from "./lib/sentry";

// Sentry muss VOR dem React-Render initialisiert werden
initSentry();

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installEmailLinkSafety } from "./lib/emailLinkSafety";

createRoot(document.getElementById("root")!).render(<App />);

// E-Mail-Links in den (sandboxed) E-Mail-iframes sicher im neuen Tab öffnen
installEmailLinkSafety();

// PWA: Service-Worker registrieren (App installierbar + immer aktuell)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
